import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  TextField,
  Button,
  Grid,
  Divider,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
  Chip,
  Tab,
  Tabs,
  Paper,
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  // ...existing code...
  CircularProgress,
  Alert,
  InputAdornment,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  Close as CloseIcon,
  Event as EventIcon,
  Person as PersonIcon,
  LocationOn as LocationIcon,
  AttachMoney as MoneyIcon,
  Group as GroupIcon,
  Save as SaveIcon,
  CalendarToday as CalendarIcon,
  Phone as PhoneIcon,
  Receipt as ReceiptIcon,
  Add as AddIcon,
  Delete as DeleteIcon,
  Notes as NotesIcon,
} from "@mui/icons-material";
import api from "../../services/api";
import BotonRecibo from "../BotonRecibo";
import BotonItinerarioMusical from "../BotonItinerarioMusical";
import BotonContrato from "../BotonContrato";
import {
  formatDateLong,
  formatDateShort,
  getCurrentISOString,
} from "../../utils/dateUtils";

// ...existing code...
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`event-tabpanel-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: { xs: 1, sm: 2 } }}>{children}</Box>}
    </div>
  );
}

// ...existing code...
const EventEditModal = ({
  open,
  onClose,
  evento,
  colaboradores: colaboradoresProp = [],
  onSave,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [activeTab, setActiveTab] = useState(0);
  const [formData, setFormData] = useState({});
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [selectedColaboradores, setSelectedColaboradores] = useState([]);
  const [colaboradoresLocal, setColaboradoresLocal] = useState([]);
  const [loadingColabs, setLoadingColabs] = useState(false);

  // Estados para Paquetes y Servicios
  const [paquetesList, setPaquetesList] = useState([]);
  const [serviciosList, setServiciosList] = useState([]);

  // Estados para Gastos
  const [gastos, setGastos] = useState([]);
  const [loadingGastos, setLoadingGastos] = useState(false);
  const [nuevoGasto, setNuevoGasto] = useState({ descripcion: "", monto: "" });
  const [addingGasto, setAddingGasto] = useState(false);

  // Cargar paquetes y servicios al abrir
  useEffect(() => {
    if (!open) return;
    const loadPaquetesServicios = async () => {
      try {
        const [resPaq, resSer] = await Promise.all([
          api.get("/paquetes"),
          api.get("/servicios"),
        ]);
        const paq = resPaq.data?.paquetes || resPaq.data?.data || resPaq.data || [];
        const ser = resSer.data?.servicios || resSer.data?.data || resSer.data || [];
        setPaquetesList(Array.isArray(paq) ? paq : []);
        setServiciosList(Array.isArray(ser) ? ser : []);
      } catch (err) {
        console.error("[EventEditModal] Error cargando paquetes/servicios:", err);
      }
    };
    loadPaquetesServicios();
  }, [open]);

  // Cargar colaboradores si no vienen como prop
  useEffect(() => {
    const loadColaboradores = async () => {
      if (colaboradoresProp.length > 0) {
        setColaboradoresLocal(colaboradoresProp);
        return;
      }
      try {
        setLoadingColabs(true);
        const response = await api.get("/colaboradores");
        console.log("[EventEditModal] Respuesta colaboradores:", response.data);
        // La API devuelve: { success: true, data: [...colaboradores] }
        const lista =
          response.data?.data ||
          response.data?.colaboradores ||
          response.data ||
          [];
        console.log("[EventEditModal] Lista de colaboradores parseada:", lista);
        setColaboradoresLocal(Array.isArray(lista) ? lista : []);
      } catch (err) {
        console.error("[EventEditModal] Error cargando colaboradores:", err);
      } finally {
        setLoadingColabs(false);
      }
    };
    if (open) {
      loadColaboradores();
    }
  }, [open, colaboradoresProp]);

  // Lista de colaboradores a usar
  const colaboradores =
    colaboradoresLocal.length > 0 ? colaboradoresLocal : colaboradoresProp;

  // Inicializar formData desde el prop (carga inmediata, puede ser parcial)
  useEffect(() => {
    if (evento) {
      setFormData({
        titulo: evento.titulo || "",
        descripcion: evento.descripcion || "",
        fecha_evento: evento.fecha_evento || evento.fecha_inicio || "",
        hora_inicio: evento.hora_inicio || "",
        hora_fin: evento.hora_fin || "",
        duracion_horas: evento.duracion_horas || null,
        estado: evento.estado || "Por Confirmar",
        ubicacion: evento.ubicacion || "",
        direccion: evento.direccion || "",
        cliente_id: evento.cliente_id || "",
        cliente_nombre: evento.cliente_nombre || "",
        cliente_telefono: evento.cliente_telefono || "",
        canal: evento.canal || "",
        costo_servicio: evento.costo_servicio || evento.monto_paquete || 0,
        anticipo: evento.anticipo || evento.adelanto || 0,
        cubierto_por_id: evento.cubierto_por_id || "",
        cubierto_por_nombre: evento.cubierto_por_nombre || "",
        colaborador_creador_id: evento.colaborador_creador_id || "",
        colaborador_nombre: evento.colaborador_nombre || "",
        paquete_nombre: evento.paquete_nombre || "",
        tipo_servicio_nombre: evento.tipo_servicio_nombre || "",
        paquete_id: evento.paquete_id || null,
        tipo_servicio_id: evento.tipo_servicio_id || null,
        notas: evento.notas || "",
      });
      if (
        evento.colaboradores_ids &&
        Array.isArray(evento.colaboradores_ids) &&
        evento.colaboradores_ids.length > 0
      ) {
        setSelectedColaboradores(
          evento.colaboradores_ids.map((id) => parseInt(id, 10)),
        );
      } else if (evento.cubierto_por_id) {
        setSelectedColaboradores([parseInt(evento.cubierto_por_id, 10)]);
      } else {
        setSelectedColaboradores([]);
      }
      setActiveTab(0);
      setError("");
    }
  }, [evento]);

  // Re-fetchear datos COMPLETOS desde la API al abrir el modal
  // (el prop puede venir de queries parciales como el dashboard)
  useEffect(() => {
    if (!open || !evento?.id) return;
    const fetchEventoCompleto = async () => {
      try {
        const response = await api.get(`/eventos/${evento.id}`);
        const eventoData = response.data?.evento || response.data;
        if (!eventoData) return;
        setFormData({
          titulo: eventoData.titulo || "",
          descripcion: eventoData.descripcion || "",
          fecha_evento: eventoData.fecha_evento || eventoData.fecha_inicio || "",
          hora_inicio: eventoData.hora_inicio || "",
          hora_fin: eventoData.hora_fin || "",
          duracion_horas: eventoData.duracion_horas || null,
          estado: eventoData.estado || "Por Confirmar",
          ubicacion: eventoData.ubicacion || "",
          direccion: eventoData.direccion || "",
          cliente_id: eventoData.cliente_id || "",
          cliente_nombre: eventoData.cliente_nombre || "",
          cliente_telefono: eventoData.cliente_telefono || "",
          canal: eventoData.canal || "",
          costo_servicio: eventoData.costo_servicio || eventoData.monto_paquete || 0,
          anticipo: eventoData.anticipo || eventoData.adelanto || 0,
          cubierto_por_id: eventoData.cubierto_por_id || "",
          cubierto_por_nombre: eventoData.cubierto_por_nombre || "",
          colaborador_creador_id: eventoData.colaborador_creador_id || "",
          colaborador_nombre: eventoData.colaborador_nombre || "",
          paquete_nombre: eventoData.paquete_nombre || "",
          tipo_servicio_nombre: eventoData.tipo_servicio_nombre || "",
          paquete_id: eventoData.paquete_id || null,
          tipo_servicio_id: eventoData.tipo_servicio_id || null,
          notas: eventoData.notas || "",
        });
        if (
          eventoData.colaboradores_ids &&
          Array.isArray(eventoData.colaboradores_ids) &&
          eventoData.colaboradores_ids.length > 0
        ) {
          setSelectedColaboradores(
            eventoData.colaboradores_ids.map((id) => parseInt(id, 10)),
          );
        } else if (eventoData.cubierto_por_id) {
          setSelectedColaboradores([parseInt(eventoData.cubierto_por_id, 10)]);
        } else {
          setSelectedColaboradores([]);
        }
      } catch (err) {
        console.error("[EventEditModal] Error cargando evento completo:", err);
      }
    };
    fetchEventoCompleto();
  }, [open, evento?.id]);

  // Cargar gastos del evento
  useEffect(() => {
    const loadGastos = async () => {
      if (!evento?.id || !open) return;
      try {
        setLoadingGastos(true);
        const response = await api.get(`/gastos?evento_id=${evento.id}`);
        const lista = response.data?.data || response.data?.gastos || [];
        setGastos(Array.isArray(lista) ? lista : []);
      } catch (err) {
        console.error("[EventEditModal] Error cargando gastos:", err);
        setGastos([]);
      } finally {
        setLoadingGastos(false);
      }
    };
    loadGastos();
  }, [evento?.id, open]);

  // Agregar gasto
  const handleAddGasto = async () => {
    if (!nuevoGasto.descripcion.trim() || !nuevoGasto.monto) {
      setError("La descripción y monto del gasto son requeridos");
      return;
    }
    try {
      setAddingGasto(true);
      const payload = {
        evento_id: evento.id,
        descripcion: nuevoGasto.descripcion.trim(),
        monto: parseFloat(nuevoGasto.monto),
      };
      const response = await api.post("/gastos", payload);
      const nuevoId =
        response.data?.data?.gasto_id || response.data?.gasto_id || Date.now();
      setGastos((prev) => [
        ...prev,
        { ...payload, id: nuevoId, fecha: getCurrentISOString() },
      ]);
      setNuevoGasto({ descripcion: "", monto: "" });
      setError("");
    } catch (err) {
      console.error("[EventEditModal] Error agregando gasto:", err);
      setError(err.response?.data?.message || "Error al agregar gasto");
    } finally {
      setAddingGasto(false);
    }
  };

  // Eliminar gasto
  const handleDeleteGasto = async (gastoId) => {
    try {
      await api.delete(`/gastos/${gastoId}`);
      setGastos((prev) => prev.filter((g) => g.id !== gastoId));
    } catch (err) {
      console.error("[EventEditModal] Error eliminando gasto:", err);
      setError(err.response?.data?.message || "Error al eliminar gasto");
    }
  };

  // Calcular total de gastos
  const totalGastos = gastos.reduce(
    (sum, g) => sum + parseFloat(g.monto || 0),
    0,
  );

  const handleChange = (field, value) => {
    setFormData((prev) => {
      const updated = { ...prev, [field]: value };
      // Calcular duración automáticamente cuando cambian las horas
      if (field === "hora_inicio" || field === "hora_fin") {
        const horaInicio = field === "hora_inicio" ? value : prev.hora_inicio;
        const horaFin = field === "hora_fin" ? value : prev.hora_fin;
        if (horaInicio && horaFin) {
          const [h1, m1] = horaInicio.split(":").map(Number);
          const [h2, m2] = horaFin.split(":").map(Number);
          const minutosInicio = h1 * 60 + m1;
          const minutosFin = h2 * 60 + m2;
          if (minutosFin > minutosInicio) {
            updated.duracion_horas = (
              (minutosFin - minutosInicio) /
              60
            ).toFixed(1);
          }
        }
      }
      return updated;
    });
  };

  const handleColaboradorToggle = (colabId) => {
    setSelectedColaboradores((prev) => {
      if (prev.includes(colabId)) {
        return prev.filter((id) => id !== colabId);
      } else {
        // Permitir múltiples colaboradores seleccionados
        return [...prev, colabId];
      }
    });
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      setError("");

      const anticipoVal = parseFloat(formData.adelanto) || parseFloat(formData.anticipo) || 0;
      if (anticipoVal < 500) {
        setError("El adelanto mínimo es de $500");
        setSaving(false);
        return;
      }

      const payload = {
        titulo: formData.titulo,
        descripcion: formData.descripcion,
        fecha_inicio: formData.fecha_evento,
        hora_inicio: formData.hora_inicio || null,
        hora_fin: formData.hora_fin || null,
        ubicacion: formData.ubicacion,
        direccion: formData.direccion,
        estado: formData.estado,
        cliente_id: formData.cliente_id, // IMPORTANTE: Incluir cliente_id
        colaboradores_ids: selectedColaboradores, // Array con múltiples colaboradores
        cubierto_por_id: selectedColaboradores[0] || null, // El primero como principal
        monto_paquete: parseFloat(formData.costo_servicio) || 0,
        adelanto:
          parseFloat(formData.adelanto) || parseFloat(formData.anticipo) || 0,
        // Campos de paquete/servicio
        paquete_id: formData.paquete_id || null,
        tipo_servicio_id: formData.tipo_servicio_id || null,
        notas: formData.notas || "",
      };

      await api.put(`/eventos/${evento.id}`, payload);

      // Actualizar datos locales con el colaborador seleccionado
      const colabSeleccionado = colaboradores.find(
        (c) => c.id === selectedColaboradores[0],
      );

      if (onSave) {
        onSave({
          ...evento,
          ...formData,
          cubierto_por_id: selectedColaboradores[0] || null,
          cubierto_por_nombre: colabSeleccionado?.nombre_completo || "",
          costo_servicio: parseFloat(formData.costo_servicio) || 0,
          anticipo: parseFloat(formData.anticipo) || 0,
          pago_restante:
            (parseFloat(formData.costo_servicio) || 0) -
            (parseFloat(formData.anticipo) || 0),
        });
      }

      onClose();
    } catch (err) {
      console.error("[EventEditModal] Error guardando:", err);
      setError(err.response?.data?.message || "Error al guardar los cambios");
    } finally {
      setSaving(false);
    }
  };

  const getEstadoColor = (estado) => {
    const colors = {
      "Por Confirmar": "warning",
      Confirmado: "primary",
      "En curso": "info",
      Completado: "success",
      Cancelado: "error",
    };
    return colors[estado] || "default";
  };

  if (!evento) return null;

  const pendiente =
    (parseFloat(formData.costo_servicio) || 0) -
    (parseFloat(formData.anticipo) || 0);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          borderRadius: { xs: 0, sm: 2 },
          maxHeight: { xs: "100vh", sm: "90vh" },
        },
      }}
    >
      {/* Header del Modal */}
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          bgcolor: "primary.main",
          color: "white",
          py: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Avatar sx={{ bgcolor: "white", color: "primary.main" }}>
            <EventIcon />
          </Avatar>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              {formData.titulo || "Evento"}
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              {formData.fecha_evento
                ? formatDateLong(formData.fecha_evento)
                : "Sin fecha"}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Chip
            label={formData.estado}
            color={getEstadoColor(formData.estado)}
            size="small"
            sx={{ fontWeight: "bold" }}
          />
          <IconButton onClick={onClose} sx={{ color: "white" }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      {/* Tabs de navegación */}
      <Box sx={{ borderBottom: 1, borderColor: "divider", bgcolor: "grey.50" }}>
        <Tabs
          value={activeTab}
          onChange={(e, v) => setActiveTab(v)}
          variant={isMobile ? "scrollable" : "fullWidth"}
          scrollButtons={isMobile ? "auto" : false}
        >
          <Tab
            icon={<EventIcon />}
            label="General"
            iconPosition="start"
            sx={{ minHeight: { xs: 42, sm: 48 }, fontSize: { xs: "0.72rem", sm: "0.875rem" } }}
          />
          <Tab
            icon={<LocationIcon />}
            label="Ubicación"
            iconPosition="start"
            sx={{ minHeight: { xs: 42, sm: 48 }, fontSize: { xs: "0.72rem", sm: "0.875rem" } }}
          />
          <Tab
            icon={<GroupIcon />}
            label="Equipo"
            iconPosition="start"
            sx={{ minHeight: { xs: 42, sm: 48 }, fontSize: { xs: "0.72rem", sm: "0.875rem" } }}
          />
          <Tab
            icon={<MoneyIcon />}
            label="Finanzas"
            iconPosition="start"
            sx={{ minHeight: { xs: 42, sm: 48 }, fontSize: { xs: "0.72rem", sm: "0.875rem" } }}
          />
          <Tab
            icon={<ReceiptIcon />}
            label="Gastos"
            iconPosition="start"
            sx={{ minHeight: { xs: 42, sm: 48 }, fontSize: { xs: "0.72rem", sm: "0.875rem" } }}
          />
        </Tabs>
      </Box>

      <DialogContent sx={{ p: { xs: 1.5, sm: 3 } }}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError("")}>
            {error}
          </Alert>
        )}

        {/* Tab: Información General */}
        <TabPanel value={activeTab} index={0}>
          <Grid container spacing={3}>
            {/* ============ SECCIÓN: INFORMACIÓN DEL CLIENTE ============ */}
            <Grid item xs={12}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  color: "primary.main",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mb: 1,
                }}
              >
                <PersonIcon /> Información del Cliente
              </Typography>
              <Divider />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Paper
                variant="outlined"
                sx={{ p: 2, bgcolor: "background.paper", borderRadius: 2 }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Avatar
                    sx={{ bgcolor: "success.main", width: 56, height: 56, boxShadow: "0 2px 8px rgba(76,175,80,0.4)" }}
                  >
                    <PersonIcon sx={{ color: "white", fontSize: 30 }} />
                  </Avatar>
                  <Box>
                    <Typography variant="caption" sx={{ color: "success.dark", fontWeight: 700, letterSpacing: 0.5, textTransform: "uppercase", fontSize: "0.7rem" }}>
                      Cliente
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 700, color: "text.primary", lineHeight: 1.2 }}
                    >
                      {formData.cliente_nombre || "Sin cliente asignado"}
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Paper
                variant="outlined"
                sx={{ p: 2, bgcolor: "background.paper", borderRadius: 2 }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <Avatar sx={{ bgcolor: "info.main", width: 56, height: 56, boxShadow: "0 2px 8px rgba(3,169,244,0.4)" }}>
                    <PhoneIcon sx={{ color: "white", fontSize: 30 }} />
                  </Avatar>
                  <Box>
                    <Typography variant="caption" sx={{ color: "info.dark", fontWeight: 700, letterSpacing: 0.5, textTransform: "uppercase", fontSize: "0.7rem" }}>
                      Teléfono
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 700, color: "text.primary", lineHeight: 1.2 }}
                    >
                      {formData.cliente_telefono || "-"}
                    </Typography>
                  </Box>
                </Box>
              </Paper>
            </Grid>

            {/* ============ SECCIÓN: INFORMACIÓN DEL EVENTO ============ */}
            <Grid item xs={12} sx={{ mt: 2 }}>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  color: "primary.main",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mb: 1,
                }}
              >
                <EventIcon /> Información del Evento
              </Typography>
              <Divider />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Título del Evento"
                value={formData.titulo}
                onChange={(e) => handleChange("titulo", e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <EventIcon color="primary" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5, height: "100%", justifyContent: "center" }}>
                <FormControl fullWidth size="small">
                  <InputLabel>📦 Paquete Contratado</InputLabel>
                  <Select
                    value={formData.paquete_id || ""}
                    label="📦 Paquete Contratado"
                    onChange={(e) => {
                      const val = e.target.value;
                      const paq = paquetesList.find((p) => p.id === val);
                      handleChange("paquete_id", val || null);
                      handleChange("paquete_nombre", paq?.nombre || "");
                      if (val) handleChange("tipo_servicio_id", null);
                    }}
                  >
                    <MenuItem value="">Sin paquete</MenuItem>
                    {paquetesList.map((p) => (
                      <MenuItem key={p.id} value={p.id}>{p.nombre}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl fullWidth size="small">
                  <InputLabel>🎯 Servicio Contratado</InputLabel>
                  <Select
                    value={formData.tipo_servicio_id || ""}
                    label="🎯 Servicio Contratado"
                    onChange={(e) => {
                      const val = e.target.value;
                      const ser = serviciosList.find((s) => s.id === val);
                      handleChange("tipo_servicio_id", val || null);
                      handleChange("tipo_servicio_nombre", ser?.nombre || "");
                      if (val) handleChange("paquete_id", null);
                    }}
                  >
                    <MenuItem value="">Sin servicio</MenuItem>
                    {serviciosList.map((s) => (
                      <MenuItem key={s.id} value={s.id}>{s.nombre}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Descripción"
                multiline
                rows={2}
                value={formData.descripcion}
                onChange={(e) => handleChange("descripcion", e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                fullWidth
                label="Fecha del Evento"
                type="date"
                value={formData.fecha_evento}
                onChange={(e) => handleChange("fecha_evento", e.target.value)}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CalendarIcon color="primary" />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={6} sm={2}>
              <TextField
                fullWidth
                label="Hora Inicio"
                type="time"
                value={formData.hora_inicio || ""}
                onChange={(e) => handleChange("hora_inicio", e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={6} sm={2}>
              <TextField
                fullWidth
                label="Hora Fin"
                type="time"
                value={formData.hora_fin || ""}
                onChange={(e) => handleChange("hora_fin", e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  textAlign: "center",
                  bgcolor: formData.duracion_horas
                    ? "success.main"
                    : "grey.100",
                  borderRadius: 2,
                  borderColor: formData.duracion_horas
                    ? "success.dark"
                    : "grey.300",
                  boxShadow: formData.duracion_horas
                    ? "0 2px 10px rgba(76,175,80,0.35)"
                    : "none",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="caption"
                  sx={{
                    fontWeight: 700,
                    letterSpacing: 0.5,
                    textTransform: "uppercase",
                    fontSize: "0.7rem",
                    color: formData.duracion_horas ? "rgba(255,255,255,0.85)" : "text.secondary",
                  }}
                >
                  Número de Horas Contratadas
                </Typography>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: "bold",
                    color: formData.duracion_horas ? "white" : "grey.500",
                  }}
                >
                  {formData.duracion_horas
                    ? `${formData.duracion_horas} hrs`
                    : "-- hrs"}
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Estado</InputLabel>
                <Select
                  value={formData.estado}
                  onChange={(e) => handleChange("estado", e.target.value)}
                  label="Estado"
                >
                  <MenuItem value="Por Confirmar">
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box
                        sx={{
                          width: 12,
                          height: 12,
                          borderRadius: "50%",
                          bgcolor: "warning.main",
                        }}
                      />
                      Por Confirmar
                    </Box>
                  </MenuItem>
                  <MenuItem value="Confirmado">
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box
                        sx={{
                          width: 12,
                          height: 12,
                          borderRadius: "50%",
                          bgcolor: "primary.main",
                        }}
                      />
                      Confirmado
                    </Box>
                  </MenuItem>
                  <MenuItem value="En curso">
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box
                        sx={{
                          width: 12,
                          height: 12,
                          borderRadius: "50%",
                          bgcolor: "info.main",
                        }}
                      />
                      En curso
                    </Box>
                  </MenuItem>
                  <MenuItem value="Completado">
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box
                        sx={{
                          width: 12,
                          height: 12,
                          borderRadius: "50%",
                          bgcolor: "success.main",
                        }}
                      />
                      Completado
                    </Box>
                  </MenuItem>
                  <MenuItem value="Cancelado">
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box
                        sx={{
                          width: 12,
                          height: 12,
                          borderRadius: "50%",
                          bgcolor: "error.main",
                        }}
                      />
                      Cancelado
                    </Box>
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </TabPanel>

        {/* Tab: Ubicación */}
        <TabPanel value={activeTab} index={1}>
          <Grid container spacing={3}>
            {/* Nombre del Lugar */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Nombre del Lugar"
                value={formData.ubicacion}
                onChange={(e) => handleChange("ubicacion", e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LocationIcon color="primary" />
                    </InputAdornment>
                  ),
                }}
                placeholder="Ej: Salón de Eventos Los Jardines"
              />
            </Grid>
            {/* Dirección Completa */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Dirección Completa"
                value={formData.direccion}
                onChange={(e) => handleChange("direccion", e.target.value)}
                multiline
                rows={2}
                placeholder="Calle, número, colonia, ciudad, código postal..."
              />
            </Grid>
            {/* Mapa + Notas lado a lado */}
            <Grid item xs={12} sm={7}>
              <Paper
                variant="outlined"
                sx={{
                  p: 0,
                  borderRadius: 2,
                  overflow: "hidden",
                  minHeight: 300,
                  height: "100%",
                }}
              >
                {formData.ubicacion || formData.direccion ? (
                  <Box>
                    <iframe
                      title="Ubicación del evento"
                      width="100%"
                      height="250"
                      frameBorder="0"
                      style={{ border: 0 }}
                      src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=${encodeURIComponent(formData.direccion || formData.ubicacion)}`}
                      allowFullScreen
                    />
                    <Box
                      sx={{
                        p: 2,
                        display: "flex",
                        gap: 2,
                        justifyContent: "center",
                        bgcolor: "grey.50",
                      }}
                    >
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<LocationIcon />}
                        onClick={() => {
                          const query = encodeURIComponent(
                            formData.direccion || formData.ubicacion,
                          );
                          window.open(
                            `https://www.google.com/maps/search/?api=1&query=${query}`,
                            "_blank",
                          );
                        }}
                      >
                        Abrir en Google Maps
                      </Button>
                      <Button
                        variant="outlined"
                        color="secondary"
                        size="small"
                        onClick={() => {
                          const query = encodeURIComponent(
                            formData.direccion || formData.ubicacion,
                          );
                          window.open(
                            `https://waze.com/ul?q=${query}&navigate=yes`,
                            "_blank",
                          );
                        }}
                        sx={{
                          borderColor: "#33ccff",
                          color: "#00c4ff",
                          "&:hover": {
                            borderColor: "#00c4ff",
                            bgcolor: "rgba(0,196,255,0.08)",
                          },
                        }}
                      >
                        🚗 Waze
                      </Button>
                    </Box>
                  </Box>
                ) : (
                  <Box sx={{ textAlign: "center", py: 4 }}>
                    <LocationIcon
                      sx={{ fontSize: 48, color: "grey.400", mb: 1 }}
                    />
                    <Typography variant="body2" color="text.secondary">
                      Ingresa una dirección para ver el mapa
                    </Typography>
                  </Box>
                )}
              </Paper>
            </Grid>

            {/* Notas Internas - lado derecho del mapa */}
            <Grid item xs={12} sm={5}>
              <Typography
                variant="subtitle2"
                sx={{
                  fontWeight: 700,
                  color: "warning.dark",
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mb: 1,
                }}
              >
                <NotesIcon fontSize="small" /> Notas Internas
              </Typography>
              <TextField
                fullWidth
                label="Notas"
                value={formData.notas}
                onChange={(e) => handleChange("notas", e.target.value)}
                multiline
                rows={10}
                placeholder="Notas del equipo, recordatorios, información adicional..."
                sx={{
                  height: "calc(100% - 32px)",
                  "& .MuiInputBase-root": { height: "100%", alignItems: "flex-start" },
                  "& .MuiOutlinedInput-root": {
                    "& fieldset": { borderColor: "warning.light" },
                    "&:hover fieldset": { borderColor: "warning.main" },
                    "&.Mui-focused fieldset": { borderColor: "warning.dark" },
                  },
                }}
              />
            </Grid>
          </Grid>
        </TabPanel>

        {/* Tab: Equipo / Colaboradores */}
        <TabPanel value={activeTab} index={2}>
          {/* Sección 1: Equipo Asignado */}
          <Box sx={{ mb: 4 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 2,
              }}
            >
              <Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <GroupIcon color="primary" />
                  Equipo Asignado
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Personal confirmado para cubrir este evento
                </Typography>
              </Box>
              <Chip
                label={`${selectedColaboradores.length} asignado${selectedColaboradores.length !== 1 ? "s" : ""}`}
                color={selectedColaboradores.length > 0 ? "success" : "default"}
                size="small"
              />
            </Box>

            {selectedColaboradores.length === 0 ? (
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  textAlign: "center",
                  borderRadius: 2,
                  bgcolor: "warning.50",
                  borderColor: "warning.main",
                  borderStyle: "dashed",
                }}
              >
                <GroupIcon
                  sx={{ fontSize: 40, color: "warning.main", mb: 1 }}
                />
                <Typography color="warning.dark" sx={{ fontWeight: 500 }}>
                  Sin personal asignado
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Selecciona colaboradores de la lista inferior
                </Typography>
              </Paper>
            ) : (
              <Paper
                variant="outlined"
                sx={{ borderRadius: 2, overflow: "hidden" }}
              >
                {/* Tabla de equipo asignado */}
                <Box
                  sx={{
                    background:
                      "linear-gradient(135deg, #00B4D8 0%, #0077B6 100%)",
                    color: "white",
                    px: 2,
                    py: 1.5,
                    borderRadius: "8px 8px 0 0",
                  }}
                >
                  <Grid container alignItems="center">
                    <Grid item xs={5}>
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: "bold" }}
                      >
                        Colaborador
                      </Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: "bold" }}
                      >
                        Rol / Especialidad
                      </Typography>
                    </Grid>
                    <Grid item xs={3} sx={{ textAlign: "center" }}>
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: "bold" }}
                      >
                        Acción
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
                {colaboradores
                  .filter((c) => selectedColaboradores.includes(c.id))
                  .map((colab, index) => (
                    <Box
                      key={colab.id}
                      sx={{
                        px: 2,
                        py: 1.5,
                        bgcolor:
                          index % 2 === 0
                            ? "rgba(0, 180, 216, 0.08)"
                            : "rgba(255,255,255,0.04)",
                        borderBottom: "1px solid",
                        borderColor: "divider",
                        "&:last-child": { borderBottom: "none" },
                      }}
                    >
                      <Grid container alignItems="center">
                        <Grid item xs={5} sx={{ minWidth: 0 }}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1.5,
                            }}
                          >
                            <Avatar
                              sx={{
                                background:
                                  "linear-gradient(135deg, #00B4D8 0%, #0077B6 100%)",
                                width: 36,
                                height: 36,
                                fontSize: "1rem",
                                fontWeight: 600,
                                flexShrink: 0,
                              }}
                            >
                              {colab.nombre_completo
                                ?.charAt(0)
                                ?.toUpperCase() || "C"}
                            </Avatar>
                            <Box sx={{ minWidth: 0 }}>
                              <Typography
                                sx={{
                                  fontWeight: 600,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {colab.nombre_completo}
                              </Typography>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                ✓ Confirmado
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
                        <Grid item xs={4} sx={{ pl: 1 }}>
                          <Chip
                            label={colab.especialidad || colab.rol || "Staff"}
                            size="small"
                            sx={{
                              bgcolor: "rgba(0, 180, 216, 0.15)",
                              color: "#00B4D8",
                              border: "1px solid rgba(0, 180, 216, 0.3)",
                              fontWeight: 500,
                            }}
                          />
                        </Grid>
                        <Grid item xs={3} sx={{ textAlign: "center", pl: 2 }}>
                          <Button
                            size="small"
                            color="error"
                            variant="outlined"
                            onClick={() => handleColaboradorToggle(colab.id)}
                            sx={{ minWidth: 80 }}
                          >
                            Remover
                          </Button>
                        </Grid>
                      </Grid>
                    </Box>
                  ))}
              </Paper>
            )}
          </Box>

          {/* Sección 2: Agregar/Cambiar Personal */}
          <Box>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                Agregar Personal
              </Typography>
              <Chip
                label="Cambio de emergencia"
                size="small"
                color="warning"
                variant="outlined"
                sx={{ fontSize: "0.7rem" }}
              />
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Colaboradores disponibles para asignar al evento
            </Typography>

            {loadingColabs ? (
              <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
                <CircularProgress size={32} />
              </Box>
            ) : colaboradores.filter(
                (c) => !selectedColaboradores.includes(c.id),
              ).length === 0 ? (
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  textAlign: "center",
                  borderRadius: 2,
                  bgcolor: "grey.50",
                }}
              >
                <Typography color="text.secondary">
                  Todos los colaboradores ya están asignados
                </Typography>
              </Paper>
            ) : (
              <Grid container spacing={2}>
                {colaboradores
                  .filter((c) => !selectedColaboradores.includes(c.id))
                  .map((colab) => (
                    <Grid item xs={12} sm={6} key={colab.id}>
                      <Paper
                        variant="outlined"
                        sx={{
                          p: 2,
                          borderRadius: 2,
                          cursor: "pointer",
                          transition: "all 0.2s",
                          "&:hover": {
                            borderColor: "primary.main",
                            bgcolor: "primary.50",
                            transform: "translateY(-2px)",
                            boxShadow: 2,
                          },
                        }}
                        onClick={() => handleColaboradorToggle(colab.id)}
                      >
                        <Box
                          sx={{ display: "flex", alignItems: "center", gap: 2 }}
                        >
                          <Avatar sx={{ bgcolor: "grey.400" }}>
                            {colab.nombre_completo?.charAt(0)?.toUpperCase() ||
                              "C"}
                          </Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography sx={{ fontWeight: 500 }}>
                              {colab.nombre_completo}
                            </Typography>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              {colab.especialidad || colab.rol || "Staff"}
                            </Typography>
                          </Box>
                          <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            sx={{ minWidth: 0 }}
                          >
                            + Agregar
                          </Button>
                        </Box>
                      </Paper>
                    </Grid>
                  ))}
              </Grid>
            )}
          </Box>

          {/* Creador del evento (solo lectura) */}
          <Box sx={{ mt: 4 }}>
            <Divider sx={{ mb: 2 }} />
            <Typography
              variant="subtitle2"
              color="text.secondary"
              sx={{ mb: 1 }}
            >
              Evento registrado por:
            </Typography>
            <Chip
              avatar={
                <Avatar sx={{ bgcolor: "primary.main" }}>
                  {(
                    formData.colaborador_nombre ||
                    formData.cubierto_por_nombre ||
                    "?"
                  ).charAt(0)}
                </Avatar>
              }
              label={
                formData.colaborador_nombre ||
                formData.cubierto_por_nombre ||
                "No asignado"
              }
              variant="outlined"
              sx={{ fontWeight: 500 }}
            />
          </Box>
        </TabPanel>

        {/* Tab: Finanzas */}
        <TabPanel value={activeTab} index={3}>
          <Grid container spacing={3}>
            {/* Resumen visual */}
            <Grid item xs={12}>
              <Paper
                sx={{
                  p: 3,
                  borderRadius: 2,
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                  color: "white",
                }}
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={4}>
                    <Box sx={{ textAlign: "center" }}>
                      <Typography variant="body2" sx={{ opacity: 0.8 }}>
                        Monto Total
                      </Typography>
                      <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                        $
                        {parseFloat(
                          formData.costo_servicio || 0,
                        ).toLocaleString("es-MX")}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Box sx={{ textAlign: "center" }}>
                      <Typography variant="body2" sx={{ opacity: 0.8 }}>
                        Anticipo Recibido
                      </Typography>
                      <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                        $
                        {parseFloat(formData.anticipo || 0).toLocaleString(
                          "es-MX",
                        )}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <Box sx={{ textAlign: "center" }}>
                      <Typography variant="body2" sx={{ opacity: 0.8 }}>
                        Pendiente
                      </Typography>
                      <Typography
                        variant="h4"
                        sx={{
                          fontWeight: "bold",
                          color: pendiente > 0 ? "#ffeb3b" : "#4caf50",
                        }}
                      >
                        ${pendiente.toLocaleString("es-MX")}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>

            {/* Campos editables */}
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Costo del Servicio"
                type="number"
                value={formData.costo_servicio}
                onChange={(e) => handleChange("costo_servicio", e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Anticipo"
                type="number"
                value={formData.anticipo}
                onChange={(e) => handleChange("anticipo", e.target.value)}
                inputProps={{ min: 500 }}
                error={parseFloat(formData.anticipo || 0) < 500}
                helperText={parseFloat(formData.anticipo || 0) < 500 ? "El adelanto mínimo es de $500" : ""}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">$</InputAdornment>
                  ),
                }}
              />
            </Grid>

            {/* Barra de progreso de pago */}
            <Grid item xs={12}>
              <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    mb: 1,
                  }}
                >
                  <Typography variant="body2" color="text.secondary">
                    Progreso de Pago
                  </Typography>
                  <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                    {formData.costo_servicio > 0
                      ? Math.round(
                          (formData.anticipo / formData.costo_servicio) * 100,
                        )
                      : 0}
                    %
                  </Typography>
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    height: 8,
                    bgcolor: "grey.200",
                    borderRadius: 4,
                    overflow: "hidden",
                  }}
                >
                  <Box
                    sx={{
                      width: `${Math.min(
                        100,
                        formData.costo_servicio > 0
                          ? (formData.anticipo / formData.costo_servicio) * 100
                          : 0,
                      )}%`,
                      height: "100%",
                      bgcolor:
                        formData.anticipo >= formData.costo_servicio
                          ? "success.main"
                          : "primary.main",
                      borderRadius: 4,
                      transition: "width 0.3s ease",
                    }}
                  />
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </TabPanel>

        {/* Tab: Gastos */}
        <TabPanel value={activeTab} index={4}>
          <Grid container spacing={3}>
            {/* Resumen de gastos */}
            <Grid item xs={12}>
              <Paper
                sx={{
                  p: 3,
                  borderRadius: 2,
                  background:
                    "linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)",
                  color: "white",
                }}
              >
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ textAlign: "center" }}>
                      <Typography variant="body2" sx={{ opacity: 0.8 }}>
                        Total de Gastos
                      </Typography>
                      <Typography variant="h4" sx={{ fontWeight: "bold" }}>
                        ${totalGastos.toLocaleString("es-MX")}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box sx={{ textAlign: "center" }}>
                      <Typography variant="body2" sx={{ opacity: 0.8 }}>
                        Ganancia Neta
                      </Typography>
                      <Typography
                        variant="h4"
                        sx={{
                          fontWeight: "bold",
                          color:
                            parseFloat(formData.costo_servicio || 0) -
                              totalGastos >=
                            0
                              ? "#4caf50"
                              : "#ffeb3b",
                        }}
                      >
                        $
                        {(
                          parseFloat(formData.costo_servicio || 0) - totalGastos
                        ).toLocaleString("es-MX")}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>

            {/* Agregar nuevo gasto */}
            <Grid item xs={12}>
              <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "bold", mb: 2 }}
                >
                  Agregar Gasto
                </Typography>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} sm={6}>
                    <TextField
                      fullWidth
                      label="Descripción"
                      value={nuevoGasto.descripcion}
                      onChange={(e) =>
                        setNuevoGasto((prev) => ({
                          ...prev,
                          descripcion: e.target.value,
                        }))
                      }
                      placeholder="Ej: Transporte, materiales, etc."
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      label="Monto"
                      type="number"
                      value={nuevoGasto.monto}
                      onChange={(e) =>
                        setNuevoGasto((prev) => ({
                          ...prev,
                          monto: e.target.value,
                        }))
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                      }}
                      size="small"
                    />
                  </Grid>
                  <Grid item xs={12} sm={2}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      onClick={handleAddGasto}
                      disabled={addingGasto}
                      startIcon={
                        addingGasto ? (
                          <CircularProgress size={16} />
                        ) : (
                          <AddIcon />
                        )
                      }
                    >
                      Agregar
                    </Button>
                  </Grid>
                </Grid>
              </Paper>
            </Grid>

            {/* Lista de gastos */}
            <Grid item xs={12}>
              <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "bold", mb: 2 }}
                >
                  Gastos Registrados ({gastos.length})
                </Typography>
                {loadingGastos ? (
                  <Box
                    sx={{ display: "flex", justifyContent: "center", py: 3 }}
                  >
                    <CircularProgress />
                  </Box>
                ) : gastos.length === 0 ? (
                  <Typography
                    color="text.secondary"
                    sx={{ textAlign: "center", py: 3 }}
                  >
                    No hay gastos registrados para este evento.
                  </Typography>
                ) : (
                  <List>
                    {gastos.map((gasto) => {
                      const esAutomatico =
                        gasto.descripcion === "Comisión por Evento Agregado" ||
                        gasto.descripcion === "Día Laborado";
                      const esDiaLaborado =
                        gasto.descripcion === "Día Laborado";

                      return (
                        <ListItem
                          key={gasto.id}
                          sx={{
                            bgcolor: esAutomatico
                              ? "rgba(2, 136, 209, 0.12)"
                              : "rgba(255,255,255,0.05)",
                            borderRadius: 1,
                            mb: 1,
                            border: "1px solid",
                            borderColor: esAutomatico
                              ? "rgba(2, 136, 209, 0.35)"
                              : "rgba(255,255,255,0.08)",
                          }}
                        >
                          <ListItemAvatar>
                            <Avatar
                              sx={{
                                bgcolor: esAutomatico
                                  ? "info.main"
                                  : "error.main",
                              }}
                            >
                              <ReceiptIcon />
                            </Avatar>
                          </ListItemAvatar>
                          <ListItemText
                            primary={
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                  pr: 1,
                                }}
                              >
                                <Typography
                                  component="span"
                                  sx={{
                                    fontSize: "0.875rem",
                                    fontWeight: 500,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {gasto.descripcion}
                                </Typography>
                                {esAutomatico && (
                                  <Chip
                                    label="Automático"
                                    size="small"
                                    color="info"
                                    sx={{ fontSize: "0.65rem", height: 20, flexShrink: 0 }}
                                  />
                                )}
                              </Box>
                            }
                            secondary={
                              <Box component="span">
                                {gasto.fecha
                                  ? formatDateShort(gasto.fecha)
                                  : "-"}
                                {esDiaLaborado && gasto.colaborador_nombre && (
                                  <Typography
                                    component="span"
                                    variant="caption"
                                    sx={{ ml: 1, color: "info.main" }}
                                  >
                                    • {gasto.colaborador_nombre}
                                  </Typography>
                                )}
                              </Box>
                            }
                            sx={{ mr: 0 }}
                          />
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1.5,
                              flexShrink: 0,
                              pl: 2,
                            }}
                          >
                            <Typography
                              variant="subtitle1"
                              sx={{ fontWeight: "bold", color: "error.main", whiteSpace: "nowrap" }}
                            >
                              -${parseFloat(gasto.monto || 0).toLocaleString("es-MX")}
                            </Typography>
                            {!esAutomatico && (
                              <IconButton
                                edge="end"
                                color="error"
                                onClick={() => handleDeleteGasto(gasto.id)}
                                size="small"
                              >
                                <DeleteIcon />
                              </IconButton>
                            )}
                          </Box>
                        </ListItem>
                      );
                    })}
                  </List>
                )}
              </Paper>
            </Grid>
          </Grid>
        </TabPanel>
      </DialogContent>

      {/* Footer con acciones */}
      <DialogActions
        sx={{
          px: 3,
          py: 2,
          bgcolor: "background.paper",
          borderTop: 1,
          borderColor: "divider",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
          <BotonRecibo evento={evento} size="small" label="Recibo PDF" />
          <BotonContrato evento={evento} size="small" />
          <BotonItinerarioMusical
            evento={{
              ...evento,
              paquete_nombre: formData.paquete_nombre,
              tipo_servicio_nombre: formData.tipo_servicio_nombre,
              titulo: formData.titulo,
              descripcion: formData.descripcion,
              cliente_nombre: formData.cliente_nombre,
              fecha_evento: formData.fecha_evento,
              hora_inicio: formData.hora_inicio,
            }}
            size="small"
          />
        </Box>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button onClick={onClose} disabled={saving} startIcon={<CloseIcon />}>
            Cancelar
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
            disabled={saving}
            startIcon={saving ? <CircularProgress size={20} /> : <SaveIcon />}
          >
            {saving ? "Guardando..." : "Guardar Cambios"}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default EventEditModal;
